import { onBeforeUnmount } from 'vue';

export type ObjectUrlHandle = {
    url: string;
    revoke: () => void;
};

export default function useObjectUrl() {
    const activeUrls = new Set<string>();

    const revokeObjectUrl = (url: string) => {
        if (!activeUrls.has(url)) {
            return;
        }

        URL.revokeObjectURL(url);
        activeUrls.delete(url);
    };

    const createObjectUrl = (file: File): ObjectUrlHandle => {
        const url = URL.createObjectURL(file);
        activeUrls.add(url);

        const revoke = () => {
            revokeObjectUrl(url);
        };

        return { url, revoke };
    };

    const revokeAllObjectUrls = () => {
        activeUrls.forEach((url) => {
            URL.revokeObjectURL(url);
        });

        activeUrls.clear();
    };

    onBeforeUnmount(() => {
        revokeAllObjectUrls();
    });

    return { createObjectUrl, revokeObjectUrl, revokeAllObjectUrls };
}
